<template>
<div class="message">
  <heads></heads>
  <div class="message-left">
    <h2>{{$t('message.title')}}</h2>
    <div class="message-type">
      <div :class="{'messageColor':type==1}" @click.stop="_change(1)">{{$t('message.system')}}</div>
      <div :class="{'messageColor':type==0}" @click.stop="_change(0)">{{$t('message.per')}}</div>
    </div>
  </div>
  <div class="message_center">
    <div class="message_center-item">
      <div v-for="item in list" @click.stop="_show(item.id,item.status)">
        <span>{{item.title}}</span>
        <span class="message-time">{{item.send_time}}</span>
      </div>
    </div>
    <div class="message_center-item" v-if="isRoll==false"><div style="justify-content: center" @click.stop="_more">MORE</div></div>
  </div>
  <div class="message-right">
    <div class="message-No" v-if="isOpen==0">{{$t('message.data')}}</div>
    <div v-else class="message-title">
      <h4>{{title}}</h4>
      <div class="message-title-time">{{time}}</div>
      <div class="message-title_info" v-html="message"></div>
      <div class="message-close"><span @click.stop="_hide">{{$t('message.close')}}</span></div>
    </div>
  </div>
</div>
</template>

<script>
  import heads from './navs/headr'
    export default {
        name: "message",
      components:{heads},
      data(){
          return{
            username:'',
            balance:"",
            phone:'',
            withdraw_bet_quota:'',
            isToken:'',
            type:1,
            list:[],
            isRoll:true,
            curPage:0,
            last_Page:0,
            list_title:{},
            title:'',
            time:'',
            message:'',
            isOpen:0,
          }
      },
      created:function(){
          let _self=this;
          _self._message();
      },
      methods:{
        _change:function(m){
          let _self=this;
          _self.type=parseFloat(m);
          _self.isRoll=true;
          _self.list=[];
          _self.curPage=0;
          _self.last_Page=0;
          _self._message();
        },
        _more:function(){
          let _self=this;
          if (_self.isRoll == false) {
            _self._message();
            _self.isRoll = true;
          }
        },
        _hide:function(){
          let _self=this;
          _self.isOpen=0;
        },
        _show:function (id,status) {
          let _self=this;
          for(var i=0;i<_self.list.length;i++){
            if(id==_self.list[i].id){
              _self.title=_self.list[i].title;
              _self.time=_self.list[i].send_time;
              _self.message=_self.list[i].message;
              _self.isOpen=1;
              if(status==0){
                _self._stateMessage(id)
              }

            }
          }
        },
        _stateMessage:function (id) {
          let _self=this;
          this._PublicFun.getData('2','put', 'message/state', {'message_id':id}, function (result) {
            if(result.data['status_code']==200){
              for(var i=0;i<_self.list.length;i++){
                if(id==_self.list[i].id){
                  _self.list[i].status=1;
                }
              }

            }

          })
        },
        _message:function () {
          let _self=this;
          let page = parseFloat(_self.curPage) + 1;
          _self.curPage = page;
          if (_self.last_Page == 0) {
            _self.last_Page = page;
          }
          this._PublicFun.getData('2','get', 'message/list/'+_self.type+'?page='+page, {}, function (result) {
            if(result.data['status_code']==200){
              let meta = result.data['meta'];
              let current_page = meta.current_page;
              if (current_page == 1) {
                _self.list = [];
              }
              if (result.data['data'].length > 0) {
                for (let i = 0; i < result.data['data'].length; i++) {
                  result.data['data'][i].show=0;
                  _self.list.push(result.data['data'][i]);
                }
              }
              if (meta.last_page <= page) {
                _self.isRoll = true;
              } else {
                _self.last_Page = meta.last_page;
                _self.isRoll = false;
              }
            }

          })
        },
      }
    }
</script>

<style scoped>
  .message{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    background-color: #ffffff;
  }
  .message-left{
    position: absolute;
    top: 45px;
    bottom: 0;
    left: 0;
    width: 250px;
    background: url("../assets/img/header-inbox.png") no-repeat center;
    background-size: 100% 100%;
    overflow-y: auto;
  }
  .message-left h2{
    color: #ffffff;
    font-weight: 600;
    font-size: 30px;
    text-align: center;
  }
  .message-type{
    display: block;
    width: 100%;
    margin: 50px auto;
    padding: 0;
    text-align: center;
  }
  .message-type div{
    display: flex;
    position: relative;
    color: #4392D9;
    font-weight: bold;
    cursor: pointer;
    padding: 15px 0;
    margin: 5px 0;
    justify-content: center;
    align-items: center;
  }
  .messageColor{
    color: #ffffff!important;
  }
  .message_center{
    position: absolute;
    left: 250px;
    width: 350px;
    top: 45px;
    bottom: 0;
    overflow-y: auto;
    background: #F1F1F1;
    box-shadow: 8px 0 5px -5px rgba(0,0,0,0.36) inset;
  }
  .message_center-item,.message_center-more{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;

  }

  .message_center-item div{
    width: 100%;
    margin: 0 auto;
    padding: 15px 0;
    position: relative;
    display: flex;
    border-bottom: 1px solid rgba(151, 151, 151, 0.26);
    cursor: pointer;
    flex-wrap: nowrap;
    align-items: center;
    -webkit-transition: all cubic-bezier(0.35, 0.1, 0.2, 1) 0.3s;
    -moz-transition: all cubic-bezier(0.35, 0.1, 0.2, 1) 0.3s;
    -ms-transition: all cubic-bezier(0.35, 0.1, 0.2, 1) 0.3s;
    -o-transition: all cubic-bezier(0.35, 0.1, 0.2, 1) 0.3s;
    transition: all cubic-bezier(0.35, 0.1, 0.2, 1) 0.3s;
  }
  .message_center-item div span:first-child{
    padding-left: 10px;
  }
  .message_center-item div:hover{
    background-color: #A8C8E4;
    box-shadow: 8px 0 5px -5px rgba(0,0,0,0.36) inset;
  }
  .message-time{
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
  }
  .message-right{
    position: absolute;
    top: 45px;
    left: 600px;
    bottom: 0;
    right: 0;
    overflow-y: auto;

  }
  .message-No{
    position: absolute;
    top: 50%;
    color: #5F5F5F;
    left: 50%;
    font-size: 18px;
    transform: translate(-50%,-50%);
  }
  .message-title{
    display: block;
    width: 90%;
    margin: 0 auto;
    padding: 10px 0;
  }
  .message-title h4{
    font-size: 1.375rem;
    line-height: 1.6;
    border-bottom: 1px solid #5F5F5F;
    margin: 0;
    padding: 15px 0;
  }
  .message-title-time{
    color: #5F5F5F;
    font-size: 14px;
    margin: 10px auto;
  }
  .message-title_info{
    display: block;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
  .message-close{
    display: flex;
    justify-content: flex-end;


  }
  .message-close span{
    border-color: #0FA3E6;
    color: #0FA3E6;
    padding: 10px 25px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #0FA3E6;
  }
</style>



// WEBPACK FOOTER //
// src/components/message.vue